import { boot } from 'quasar/wrappers'
import DragDropTouch from '../functions/drag-drop-touch'

export default boot(({ app }) => {
	app.config.globalProperties.$DragDropTouch = DragDropTouch
})
